<template>
  <header class="mb-4">
    <h1 class="text-sm font-bold uppercase">
      <slot />
    </h1>
    <slot name="after-heading" />
  </header>
</template>
